var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { staticClass: "app-main-inner" },
        [
          _c(
            "el-form",
            {
              staticClass: "section",
              staticStyle: { "flex-direction": "row" },
              attrs: { disabled: _vm.readonly }
            },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { no: "booking" },
                  model: {
                    value: _vm.form.booking,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "booking", $$v)
                    },
                    expression: "form.booking"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Booking")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "customs" },
                  on: {
                    change: function(val) {
                      _vm.form.customsBroker = val ? _vm.form.customsBroker : 0
                      _vm.form.customsDeclarationType = val
                        ? _vm.form.customsDeclarationType
                        : -1
                    }
                  },
                  model: {
                    value: _vm.form.customs,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "customs", $$v)
                    },
                    expression: "form.customs"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.WhetherDeclarations")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "isInsure" },
                  model: {
                    value: _vm.form.insure,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "insure", $$v)
                    },
                    expression: "form.insure"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.InsureInfo")) + " ")]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "vgm" },
                  model: {
                    value: _vm.form.vgm,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "vgm", $$v)
                    },
                    expression: "form.vgm"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Vgm")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "ams" },
                  model: {
                    value: _vm.form.ams,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "ams", $$v)
                    },
                    expression: "form.ams"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Anti_terrorismShipping")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "batch" },
                  model: {
                    value: _vm.form.batch,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "batch", $$v)
                    },
                    expression: "form.batch"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.InBatchesOrNot")))]
              ),
              _vm.isBookingNew
                ? _c(
                    "el-checkbox",
                    {
                      staticStyle: { "margin-left": "-20px" },
                      attrs: { no: "destinationPortService" },
                      on: {
                        change: function($event) {
                          return _vm.syncSlaves("destinationPortService")
                        }
                      },
                      model: {
                        value: _vm.form.destinationPortService,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "destinationPortService", $$v)
                        },
                        expression: "form.destinationPortService"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.PortOfDestinationServices"))
                      )
                    ]
                  )
                : _vm._e(),
              !!_vm.templateName
                ? _c("div", { staticStyle: { "flex-grow": "1" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        staticStyle: {
                          float: "right",
                          "margin-right": "30px",
                          padding: "0 5px",
                          "white-space": "nowrap"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_SopTemplate")) +
                            ": " +
                            _vm._s(_vm.templateName)
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ],
            1
          ),
          _c(
            "tab-booking-master-UICustom-layout",
            { attrs: { "element-blocks": _vm.elementBlocks } },
            [
              _vm.elementDict.jobNo.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "jobNo" }, slot: "jobNo" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.jobNo.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.jobNo.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { value: _vm.form.jobNo, disabled: true }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isZY
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: { slot: "saleProductCode" },
                        slot: "saleProductCode"
                      },
                      [
                        _c("line-label", {
                          staticClass: "blue",
                          attrs: {
                            slot: "label",
                            label: _vm.$t("SeaExport.AllowSaleProduct")
                          },
                          slot: "label"
                        }),
                        _c("cargo-advance-select", {
                          attrs: {
                            "select-type":
                              _vm.selectTypeNames.basic_data_AllowSaleProduct,
                            filterable: "",
                            no: "allowSaleProduct",
                            clearable: "",
                            "data-filter-function": function(p) {
                              if (!p.statusEnabled) {
                                return false
                              }
                              return _vm.isFba ? p.fbaSea : p.seaExportEnabled
                            },
                            "default-value": this.form.saleProductCode || "",
                            disabled: _vm.readonly
                          },
                          on: {
                            parentCallBack: function(p) {
                              this$1.form.saleProductCode = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { slot: "fullOrInside" }, slot: "fullOrInside" },
                      [
                        _c("line-label", {
                          staticClass: "blue",
                          attrs: {
                            slot: "label",
                            label: _vm.$t("SeaExport.FullOrInside")
                          },
                          slot: "label"
                        }),
                        _c("cargo-advance-select", {
                          attrs: {
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_FullOrInside$FULL_OR_INSIDE,
                            no: "fullOrInside",
                            clearable: "",
                            "default-value": this.form.fullOrInside || "",
                            disabled: _vm.readonly
                          },
                          on: {
                            parentCallBack: function(p) {
                              this$1.form.fullOrInside = p.value
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm.form.containerLoadType === _vm.BC_CARGO_TYPE.code
                ? [
                    _vm.elementDict.customerId.viewable
                      ? _c(
                          "el-form-item",
                          { attrs: { slot: "customerId" }, slot: "customerId" },
                          [
                            _c("line-label", {
                              attrs: {
                                slot: "label",
                                label: _vm.elementDict.customerId.label
                              },
                              slot: "label"
                            }),
                            _c("cargo-sales-company-select", {
                              staticClass: "shipper-selector",
                              attrs: {
                                no: "customerId",
                                "popper-class": "shipper-selector-popper",
                                "method-params": {
                                  customer: true,
                                  companyLob: "seaExport",
                                  active: true
                                },
                                "check-credit": true,
                                "default-value": _vm.form.customerId || "",
                                disabled:
                                  _vm.readonly ||
                                  !_vm.elementDict.customerId.writable,
                                job: _vm.form,
                                "latest-used-data-key":
                                  _vm.elementDict.customerId
                                    .userCustomContent &&
                                  _vm.elementDict.customerId.userCustomContent
                                    .recentlyUsedDropdownData
                                    ? "seaBooking-customerId"
                                    : ""
                              },
                              on: { parentCallBack: _vm.customerIdChange }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.elementDict.customerProperty.viewable
                      ? _c(
                          "el-form-item",
                          {
                            attrs: { slot: "customerProperty" },
                            slot: "customerProperty"
                          },
                          [
                            _c("line-label", {
                              class: _vm.elementDict.customerProperty.isRequire
                                ? "blue"
                                : "",
                              attrs: {
                                slot: "label",
                                label: _vm.elementDict.customerProperty.label
                              },
                              slot: "label"
                            }),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.customerTip,
                                  placement: "bottom"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          (_vm.contractStatus === 2 &&
                                            typeof _vm.customerLevel.level ===
                                              "number") ||
                                          parseInt(_vm.customerLevel.level) >
                                            -1,
                                        expression:
                                          "(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
                                      }
                                    ],
                                    staticClass: "orange"
                                  },
                                  [
                                    _vm._v(
                                      "LV" + _vm._s(_vm.customerLevel.level)
                                    )
                                  ]
                                ),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          (_vm.contractStatus === 2 &&
                                            typeof _vm.customerLevel.level ===
                                              "number") ||
                                          parseInt(_vm.customerLevel.level) >
                                            -1,
                                        expression:
                                          "(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
                                      }
                                    ],
                                    staticStyle: { color: "#D3A73B" }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.customerLevel.customerName)
                                    )
                                  ]
                                ),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.contractStatusLabel,
                                        expression: "contractStatusLabel"
                                      }
                                    ],
                                    staticClass: "red"
                                  },
                                  [
                                    _vm._v(
                                      " (" +
                                        _vm._s(_vm.contractStatusLabel) +
                                        ")"
                                    )
                                  ]
                                ),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.advancePaymentLabel,
                                        expression: "advancePaymentLabel"
                                      }
                                    ],
                                    staticStyle: { color: "brown" }
                                  },
                                  [
                                    _vm._v(
                                      " (" +
                                        _vm._s(_vm.advancePaymentLabel) +
                                        ")"
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.elementDict.customerContact.viewable
                      ? _c(
                          "el-form-item",
                          {
                            attrs: { slot: "customerContact" },
                            slot: "customerContact"
                          },
                          [
                            _c("line-label", {
                              class: _vm.elementDict.customerContact.isRequire
                                ? "blue"
                                : "",
                              attrs: {
                                slot: "label",
                                label: _vm.elementDict.customerContact.label
                              },
                              slot: "label"
                            }),
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      disabled:
                                        _vm.readonly ||
                                        !_vm.elementDict.customerContact
                                          .writable,
                                      no: "customerContact",
                                      filterable: "",
                                      "allow-create": true
                                    },
                                    model: {
                                      value: _vm.form.customerContact,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "customerContact",
                                          $$v
                                        )
                                      },
                                      expression: "form.customerContact"
                                    }
                                  },
                                  _vm._l(_vm.contactList, function(
                                    item,
                                    index
                                  ) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.contactPerson,
                                        value: item.contactPerson
                                      }
                                    })
                                  }),
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-link",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.isShowContactPersonDetail,
                                        expression: "!isShowContactPersonDetail"
                                      }
                                    ],
                                    class: _vm.form.customerContact
                                      ? ""
                                      : "not-click",
                                    attrs: { no: "customerContactLink" },
                                    on: { click: _vm.showContactDialog }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.Detail")) + " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm.elementDict.containerLoadType.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "containerLoadType" },
                      slot: "containerLoadType"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.containerLoadType.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.containerLoadType.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "containerLoadType",
                            disabled:
                              _vm.readonly ||
                              !_vm.elementDict.containerLoadType.writable
                          },
                          on: {
                            change: function($event) {
                              _vm.pm.selectDefaultCutomJobType()
                              _vm.pm.containerLoadTypeChange()
                            }
                          },
                          model: {
                            value: _vm.form.containerLoadType,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "containerLoadType", $$v)
                            },
                            expression: "form.containerLoadType"
                          }
                        },
                        _vm._l(_vm.containerLoadTypes, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.bookingDate.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "bookingDate" }, slot: "bookingDate" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.bookingDate.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.bookingDate.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "bookingDate",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.bookingDate.writable,
                          type: "date",
                          clearable: "",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.form.bookingDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "bookingDate", $$v)
                          },
                          expression: "form.bookingDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.etd.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "etd" }, slot: "etd" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.etd.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.etd.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            staticClass: "departure-date-picker",
                            staticStyle: { flex: "1", "margin-right": "5px" },
                            attrs: {
                              no: "etd",
                              value: _vm.form.etd,
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.etd.writable ||
                                !_vm.isJydEditJobFields,
                              type: "date",
                              "value-format": "yyyy-MM-dd",
                              placeholder: _vm.$t("SeaExport.RequiredItem")
                            },
                            on: {
                              input: _vm.etdChange,
                              change: function($event) {
                                return _vm.onFieldChange("etd")
                              }
                            }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm._f("filterWeek")(_vm.form.sailingDay))
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.eta.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "eta" }, slot: "eta" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.eta.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.eta.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { flex: "1", "margin-right": "5px" },
                            attrs: {
                              no: "eta",
                              disabled:
                                _vm.readonly || !_vm.elementDict.eta.writable,
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            on: { input: _vm.etaChange },
                            model: {
                              value: _vm.form.eta,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "eta", $$v)
                              },
                              expression: "form.eta"
                            }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("filterWeek")(_vm.form.etaSailingDay)
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.atd.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "atd" }, slot: "atd" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.atd.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.atd.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { flex: "1", "margin-right": "5px" },
                            attrs: {
                              value: _vm.form.atd,
                              no: "atd",
                              disabled:
                                _vm.readonly || !_vm.elementDict.atd.writable,
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            on: { input: _vm.atdChange }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("filterWeek")(_vm.form.atdSailingDay)
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.ata.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "ata" }, slot: "ata" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.ata.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.ata.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { flex: "1", "margin-right": "5px" },
                            attrs: {
                              no: "ata",
                              disabled:
                                _vm.readonly || !_vm.elementDict.ata.writable,
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            on: { input: _vm.ataChange },
                            model: {
                              value: _vm.form.ata,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "ata", $$v)
                              },
                              expression: "form.ata"
                            }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("filterWeek")(_vm.form.ataSailingDay)
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customsDate.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "customsDate" }, slot: "customsDate" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customsDate.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customsDate.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "customsDate",
                          type: "date",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.customsDate.writable ||
                            !_vm.isJydUpdateCustomsDate,
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.form.customsDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "customsDate", $$v)
                          },
                          expression: "form.customsDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.elementDict.loadingPortCode.viewable,
                      expression: "elementDict.loadingPortCode.viewable"
                    }
                  ],
                  attrs: { slot: "loadingPortCode" },
                  slot: "loadingPortCode"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.loadingPortCode.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.loadingPortCode.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between"
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        ref: "loadingPortCode",
                        staticStyle: { width: "128px" },
                        attrs: {
                          no: "loadingPortCode",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.loadingPortCode.writable,
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.form.loadingPortCode,
                          "tag-name": "englishName",
                          placeholder: _vm.$t("SeaExport.RequiredItem"),
                          "latest-used-data-key":
                            _vm.elementDict.loadingPortCode.userCustomContent &&
                            _vm.elementDict.loadingPortCode.userCustomContent
                              .recentlyUsedDropdownData
                              ? "seaBooking-loadingPortCode"
                              : ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.loadingPortCodeChange(p)
                            _vm.pm.cargoDocChangeHandler()
                          }
                        }
                      }),
                      _vm.elementDict.transferPortCode.viewable
                        ? [
                            _vm._v(" "),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "padding-left": "2px" },
                                attrs: {
                                  disabled:
                                    _vm.readonly ||
                                    !_vm.elementDict.loadingPortCode.writable,
                                  no: "transfering"
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.pm.updateSecondVesselInfo()
                                  }
                                },
                                model: {
                                  value: _vm.form.transfering,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "transfering", $$v)
                                  },
                                  expression: "form.transfering"
                                }
                              },
                              [_vm._v(_vm._s(_vm.fieldDict.transfering.label))]
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              ),
              _vm.elementDict.transferPortCode.viewable && _vm.form.transfering
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "transferPortCode" },
                      slot: "transferPortCode"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.transferPortCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.transferPortCode.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "transferPortCode",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.transferPortCode.writable,
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.form.transferPortCode
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.transferPortCode = p.value
                            _vm.pm.updateSecondVesselInfo()
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.dischargingPortCode.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "dischargingPortCode" },
                      slot: "dischargingPortCode"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.dischargingPortCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.dischargingPortCode.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "dischargingPortCode",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.dischargingPortCode.writable,
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.form.dischargingPortCode,
                          placeholder: _vm.$t("SeaExport.RequiredItem"),
                          "latest-used-data-key":
                            _vm.elementDict.dischargingPortCode
                              .userCustomContent &&
                            _vm.elementDict.dischargingPortCode
                              .userCustomContent.recentlyUsedDropdownData
                              ? "seaBooking-dischargingPortCode"
                              : ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.dischargingPortCodeChange(
                              p,
                              _vm.form.carrierId
                            )
                            _vm.pm.cargoDocChangeHandler()
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.destinationPortCode.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "destinationPortCode" },
                      slot: "destinationPortCode"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.destinationPortCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.destinationPortCode.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        staticClass: "port-of-delivery-selector",
                        attrs: {
                          no: "destinationPortCode",
                          "popper-class": "port-of-delivery-selector-popper",
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.form.destinationPortCode,
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.destinationPortCode.writable,
                          placeholder: _vm.$t("SeaExport.RequiredItem"),
                          "latest-used-data-key":
                            _vm.elementDict.destinationPortCode
                              .userCustomContent &&
                            _vm.elementDict.destinationPortCode
                              .userCustomContent.recentlyUsedDropdownData
                              ? "seaBooking-destinationPortCode"
                              : ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.destinationPortCodeChange(p)
                            _vm.pm.cargoDocChangeHandler()
                            _vm.pm.changeDestinationPort()
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.placeOfDeliveryRegion.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "placeOfDeliveryRegion" },
                      slot: "placeOfDeliveryRegion"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.placeOfDeliveryRegion.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.placeOfDeliveryRegion.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "placeOfDeliveryRegion",
                          "select-type": _vm.selectTypeNames.basic_data_Region,
                          filterable: "",
                          "default-value": _vm.form.placeOfDeliveryRegion,
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.placeOfDeliveryRegion.writable
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.placeOfDeliveryRegion = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.transshipmentTransportationModeCode &&
              _vm.elementDict.transshipmentTransportationModeCode.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "transshipmentTransportationModeCode" },
                      slot: "transshipmentTransportationModeCode"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict
                          .transshipmentTransportationModeCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label:
                            _vm.elementDict.transshipmentTransportationModeCode
                              .label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "transportationMode",
                          "static-options": _vm.transportationModeInfos,
                          "filter-tag-names": [
                            "chineseName",
                            "englishName",
                            "code"
                          ],
                          filterable: "",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.transshipmentTransportationModeCode
                              .writable,
                          "tag-name": "englishName",
                          "default-value":
                            _vm.form.transshipmentTransportationModeCode
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.transshipmentTransportationModeCode =
                              p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.bookingAgent.viewable && _vm.bookingAgentVisible
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "bookingAgent" }, slot: "bookingAgent" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.bookingAgent.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.bookingAgent.label
                        },
                        slot: "label"
                      }),
                      !_vm.isJoinCarrierBookingAgent ||
                      _vm.form.containerLoadType === "BB"
                        ? _c("cargo-company-select", {
                            staticClass: "booking-agent-selector",
                            attrs: {
                              no: "bookingAgent",
                              "popper-class": "booking-agent-selector-popper",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.bookingAgent.writable ||
                                !_vm.bookingAgentEnabled,
                              "method-params": {
                                bookingAgent: true,
                                active: true
                              },
                              "default-value": _vm.form.bookingAgent || "",
                              placeholder: _vm.$t("SeaExport.RequiredItem"),
                              "latest-used-data-key":
                                _vm.elementDict.bookingAgent
                                  .userCustomContent &&
                                _vm.elementDict.bookingAgent.userCustomContent
                                  .recentlyUsedDropdownData
                                  ? "seaBooking-bookingAgent"
                                  : ""
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.bookingAgentChange(p)
                              }
                            }
                          })
                        : _vm._e(),
                      _vm.isJoinCarrierBookingAgent &&
                      _vm.form.containerLoadType !== "BB"
                        ? _c("cargo-advance-select", {
                            staticClass: "booking-agent-selector",
                            attrs: {
                              no: "bookingAgent",
                              "popper-class": "booking-agent-selector-popper",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.bookingAgent.writable ||
                                !_vm.bookingAgentEnabled,
                              "select-type":
                                _vm.selectTypeNames.static_data_Company,
                              cache: false,
                              filterable: "",
                              "default-value": _vm.form.bookingAgent || "",
                              "static-options": _vm.bookingAgentList,
                              placeholder: _vm.$t("SeaExport.RequiredItem"),
                              "latest-used-data-key":
                                _vm.elementDict.bookingAgent
                                  .userCustomContent &&
                                _vm.elementDict.bookingAgent.userCustomContent
                                  .recentlyUsedDropdownData
                                  ? "seaBooking-bookingAgent"
                                  : ""
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.bookingAgentChange(p)
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.carrierAgentId.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "carrierAgentId" },
                      slot: "carrierAgentId"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.carrierAgentId.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.carrierAgentId.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-company-select", {
                        attrs: {
                          no: "carrierAgentId",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.carrierAgentId.writable,
                          "method-params": { seaCmpAgent: true, active: true },
                          "default-value": _vm.form.carrierAgentId || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.form.carrierAgentId = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.terminalCompany.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "terminalCompany" },
                      slot: "terminalCompany"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.terminalCompany.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.terminalCompany.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-company-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "terminalCompany",
                          "method-params": {
                            terminalCompany: true,
                            companyLob: "seaExport",
                            active: true
                          },
                          "default-value": _vm.form.terminalCompany || "",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.terminalCompany.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.JobUtils.terminalCompanyChangeHandler(
                              _vm.form,
                              p
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.elementDict.carrierId.viewable,
                      expression: "elementDict.carrierId.viewable"
                    }
                  ],
                  attrs: { slot: "carrierId" },
                  slot: "carrierId"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.carrierId.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.carrierId.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    ref: "shippingCompany",
                    attrs: {
                      no: "carrierId",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.carrierId.writable ||
                        !_vm.carrierIdEnabled,
                      "method-params": {
                        companyLob: "seaExport",
                        seaCmp: true,
                        active: true
                      },
                      "default-value": _vm.form.carrierId || "",
                      "latest-used-data-key":
                        _vm.elementDict.carrierId.userCustomContent &&
                        _vm.elementDict.carrierId.userCustomContent
                          .recentlyUsedDropdownData
                          ? "seaBooking-carrierId"
                          : ""
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.carrierChangeHandler(
                          p,
                          this$1.scacList,
                          this$1.carrierScacEdit
                        )
                      }
                    }
                  })
                ],
                1
              ),
              _vm.elementDict.carrierScac &&
              _vm.elementDict.carrierScac.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "carrierScac" }, slot: "carrierScac" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.carrierScac.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.carrierScac.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "carrierScac",
                          filterable: "",
                          "custom-label": function(item) {
                            return (
                              "[" +
                              item.code +
                              "]" +
                              (item.englishName ? item.englishName : item.code)
                            )
                          },
                          "filter-tag-names": ["code", "englishName"],
                          "show-custom-label-in-option": true,
                          "static-options": _vm.scacList,
                          "tag-value": "code",
                          disabled:
                            _vm.readonly ||
                            !_vm.carrierScacEdit ||
                            !_vm.elementDict.carrierScac.writable,
                          "default-value": _vm.form.carrierScac || "",
                          "latest-used-data-key":
                            _vm.elementDict.carrierScac.userCustomContent &&
                            _vm.elementDict.carrierScac.userCustomContent
                              .recentlyUsedDropdownData
                              ? "seaBooking-carrierScac"
                              : ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.carrierScac = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cargoSource.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "cargoSource" }, slot: "cargoSource" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoSource.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cargoSource.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                disabled:
                                  _vm.readonly ||
                                  !_vm.elementDict.cargoSource.writable,
                                no: "cargoSource",
                                placeholder: _vm.$t("SeaExport.PleaseSelect"),
                                clearable: false,
                                size: "mini"
                              },
                              on: {
                                change: function($event) {
                                  _vm.form.designationAgent = 0
                                  _vm.pm.cargoSourceChange()
                                }
                              },
                              model: {
                                value: _vm.form.cargoSource,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "cargoSource", $$v)
                                },
                                expression: "form.cargoSource"
                              }
                            },
                            _vm._l(_vm.CARGO_SOURCES, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm.isZh
                                    ? item.chineseName
                                    : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.elementDict.customJobType.viewable,
                      expression: "elementDict.customJobType.viewable"
                    }
                  ],
                  attrs: { slot: "customJobType" },
                  slot: "customJobType"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customJobType.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customJobType.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    ref: "customJobType",
                    attrs: {
                      no: "customJobType",
                      "select-type":
                        _vm.selectTypeNames.basic_data_CutomJobType,
                      filterable: "",
                      "default-value": _vm.form.customJobType,
                      "static-options": _vm.customJobTypeList,
                      "method-params": { type: _vm.form.lob },
                      disabled:
                        _vm.readonly || !_vm.elementDict.customJobType.writable
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.customJobType = p.value
                        _vm.onCustomJobTypeChange()
                        _vm.contractRuleFieldChange(
                          _vm.form.customerId,
                          _vm.form.designationAgent
                        )
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.secondaryCustomJobType.viewable &&
                        _vm.form.customJobType &&
                        _vm.secondaryCustomJobTypeList.length > 0,
                      expression:
                        "elementDict.secondaryCustomJobType.viewable && form.customJobType && secondaryCustomJobTypeList.length > 0"
                    }
                  ],
                  attrs: { slot: "secondaryCustomJobType" },
                  slot: "secondaryCustomJobType"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.secondaryCustomJobType.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.secondaryCustomJobType.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    ref: "secondaryCustomJobType",
                    attrs: {
                      no: "secondaryCustomJobType",
                      "select-type":
                        _vm.selectTypeNames.basic_data_CutomJobType,
                      filterable: "",
                      cache: false,
                      "default-value": _vm.form.secondaryCustomJobType,
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.secondaryCustomJobType.writable,
                      "tag-name": _vm.isZh ? "name" : "englishName",
                      "static-options": _vm.secondaryCustomJobTypeList
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.secondaryCustomJobType = p.value
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.elementDict.destinationAgent.viewable,
                      expression: "elementDict.destinationAgent.viewable"
                    }
                  ],
                  attrs: { slot: "destinationAgent" },
                  slot: "destinationAgent"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.destinationAgent.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.destinationAgent.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: _vm.destinationAgentTip,
                        disabled: !_vm.showDestinationAgentWarning,
                        placement: "right-end"
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        ref: "destinationAgent",
                        attrs: {
                          no: "destinationAgent",
                          "method-params": { overseaAgent: true, active: true },
                          "check-credit": true,
                          job: _vm.form,
                          "default-value": _vm.form.destinationAgent || "",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.destinationAgent.writable,
                          filterable: "",
                          headers: [_vm.$t("Partners.englishName")],
                          fields: ["englishName"],
                          "tag-name": "englishName",
                          "latest-used-data-key":
                            _vm.elementDict.destinationAgent
                              .userCustomContent &&
                            _vm.elementDict.destinationAgent.userCustomContent
                              .recentlyUsedDropdownData
                              ? "seaBooking-destinationAgent"
                              : ""
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.txtDestinationAgentChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.elementDict.designationAgent.viewable &&
              _vm.form.cargoSource === "NC"
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "designationAgent" },
                      slot: "designationAgent"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.designationAgent.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.designationAgent.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.designationAgentTip,
                            disabled: !_vm.showDesignationAgentWarning,
                            placement: "right-end"
                          }
                        },
                        [
                          _c("cargo-company-select", {
                            staticClass: "designation-agent-selector",
                            attrs: {
                              no: "designationAgent",
                              "popper-class":
                                "designation-agent-selector-popper",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.designationAgent.writable ||
                                !_vm.designationAgentEnabled,
                              "method-params": {
                                designationAgent: true,
                                active: true
                              },
                              "check-credit": true,
                              job: _vm.form,
                              "default-value": _vm.form.designationAgent || "",
                              headers: [_vm.$t("Partners.englishName")],
                              fields: ["englishName"],
                              "tag-name": "englishName"
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.txtDesignationAgentChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.exChangeAgent.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "exChangeAgent" }, slot: "exChangeAgent" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.exChangeAgent.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.exChangeAgent.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-company-select", {
                        attrs: {
                          no: "exChangeAgent",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.exChangeAgent.writable ||
                            !_vm.form.destinationPortService,
                          "method-params": { bookingAgent: true, active: true },
                          "default-value": _vm.form.exChangeAgent || ""
                        },
                        on: { change: _vm.onExChangeAgentChange }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.transportSource.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "transportSource" },
                      slot: "transportSource"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.transportSource.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.transportSource.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_TransportSource,
                          no: "transportSource",
                          "default-value": _vm.form.transportSource,
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.transportSource.writable,
                          cache: false,
                          "tag-value": "code",
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(item) {
                            return (_vm.form.transportSource = item.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.statisticArea.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "statisticArea" }, slot: "statisticArea" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.statisticArea.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.statisticArea.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_StatisticArea,
                          no: "statisticArea",
                          "default-value": _vm.form.statisticArea,
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.statisticArea.writable,
                          cache: false,
                          "tag-value": "code",
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(item) {
                            return (_vm.form.statisticArea = item.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.localService.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "localService" }, slot: "localService" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.localService.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.localService.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { display: "block" },
                          attrs: {
                            disabled:
                              _vm.readonly ||
                              !_vm.elementDict.localService.writable,
                            no: "warehousing"
                          },
                          on: {
                            change: function($event) {
                              return _vm.pm.loadingTermChange("warehousing")
                            }
                          },
                          model: {
                            value: _vm.form.warehousing,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "warehousing", $$v)
                            },
                            expression: "form.warehousing"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SeaExport.WarehouseLoadingStorage")
                            ) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { display: "block" },
                          attrs: {
                            disabled:
                              _vm.readonly ||
                              !_vm.elementDict.localService.writable,
                            no: "landTransportation"
                          },
                          on: {
                            change: function($event) {
                              return _vm.pm.loadingTermChange(
                                "landTransportation"
                              )
                            }
                          },
                          model: {
                            value: _vm.form.landTransportation,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "landTransportation", $$v)
                            },
                            expression: "form.landTransportation"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.DoorLoadingDelivery")) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { display: "block" },
                          attrs: {
                            disabled:
                              _vm.readonly ||
                              !_vm.elementDict.localService.writable,
                            no: "selfDeliver"
                          },
                          model: {
                            value: _vm.form.selfDeliver,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "selfDeliver", $$v)
                            },
                            expression: "form.selfDeliver"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SeaExport.NotResponsibleForTruckingAndLoading"
                              )
                            ) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: {
                            disabled:
                              _vm.readonly ||
                              !_vm.elementDict.localService.writable,
                            no: "backUpWarehouse"
                          },
                          on: {
                            change: function($event) {
                              return _vm.pm.backUpWarehouseChange()
                            }
                          },
                          model: {
                            value: _vm.form.backUpWarehouse,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "backUpWarehouse", $$v)
                            },
                            expression: "form.backUpWarehouse"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.BackUpWarehouse")) + " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.portOfDestinationServices.viewable &&
              !_vm.isFba &&
              _vm.isBookingNew &&
              _vm.form.destinationPortService
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "portOfDestinationServices" },
                      slot: "portOfDestinationServices"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.portOfDestinationServices
                          .isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.portOfDestinationServices.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { display: "block" },
                          attrs: {
                            disabled:
                              _vm.readonly ||
                              !_vm.elementDict.portOfDestinationServices
                                .writable,
                            no: "dischargingPortDoor"
                          },
                          model: {
                            value: _vm.form.dischargingPortDoor,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "dischargingPortDoor", $$v)
                            },
                            expression: "form.dischargingPortDoor"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SeaExport.DispatchVehiclesAtDestination")
                            ) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { display: "block" },
                          attrs: {
                            disabled:
                              _vm.readonly ||
                              !_vm.elementDict.portOfDestinationServices
                                .writable,
                            no: "usCustomsClearance"
                          },
                          model: {
                            value: _vm.form.usCustomsClearance,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "usCustomsClearance", $$v)
                            },
                            expression: "form.usCustomsClearance"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("queryJob.UsCustomsClearance")) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { display: "block" },
                          attrs: {
                            disabled:
                              _vm.readonly ||
                              !_vm.elementDict.portOfDestinationServices
                                .writable,
                            no: "destPortCustomsClearance"
                          },
                          on: {
                            change: function($event) {
                              return _vm.syncSlaves("destPortCustomsClearance")
                            }
                          },
                          model: {
                            value: _vm.form.destPortCustomsClearance,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.form,
                                "destPortCustomsClearance",
                                $$v
                              )
                            },
                            expression: "form.destPortCustomsClearance"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SeaExport.PortOfDestinationCustomsClearance"
                              )
                            ) + " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customerRefNo.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "customerRefNo", id: "customerRefNo" },
                      slot: "customerRefNo"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customerRefNo.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customerRefNo.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            disabled: !_vm.customerRefNoTip,
                            content: _vm.customerRefNoTip,
                            placement: "right-end"
                          }
                        },
                        [
                          _c("el-input", {
                            class: _vm.customerRefNoTip ? "red" : "",
                            attrs: {
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.customerRefNo.writable,
                              no: "customerRefNo"
                            },
                            on: {
                              blur: function($event) {
                                return _vm.pm.customerRefNoFocusOutHandler()
                              }
                            },
                            model: {
                              value: _vm.form.customerRefNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "customerRefNo", $$v)
                              },
                              expression: "form.customerRefNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.agentRefNo.viewable &&
              _vm.form.cargoSource === "NC"
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "agentRefNo", id: "agentRefNo" },
                      slot: "agentRefNo"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.agentRefNo.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.agentRefNo.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.agentRefNo.writable,
                          no: "agentRefNo"
                        },
                        model: {
                          value: _vm.form.agentRefNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "agentRefNo", $$v)
                          },
                          expression: "form.agentRefNo"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.poNo.viewable
                ? _c(
                    "el-form-item",
                    {
                      class: _vm.poNoRed ? "poNoClass" : "",
                      attrs: { slot: "poNo" },
                      slot: "poNo"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.poNo.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.poNo.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.readonly || !_vm.elementDict.poNo.writable,
                          no: "poNo"
                        },
                        model: {
                          value: _vm.form.poNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "poNo", $$v)
                          },
                          expression: "form.poNo"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.freightTerm.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "freightTerm" }, slot: "freightTerm" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.freightTerm.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.freightTerm.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "freightTerm",
                          "select-type":
                            _vm.selectTypeNames.basic_data_ShippingTerm,
                          filterable: "",
                          "default-value": _vm.form.freightTerm,
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.freightTerm.writable
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.freightTerm = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.paymentTermMBL.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "paymentTermMBL" },
                      slot: "paymentTermMBL"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.paymentTermMBL.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.paymentTermMBL.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "paymentTermMBL",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.paymentTermMBL.writable,
                          "select-type":
                            _vm.selectTypeNames.basic_data_PaymentTerm,
                          filterable: "",
                          "default-value": _vm.form.paymentTermMBL
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.paymentTermMBL = p.value
                            _vm.pm.paymentTermMBLChange()
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customsBroker.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "customsBroker" }, slot: "customsBroker" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customsBroker.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customsBroker.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-company-select", {
                        attrs: {
                          no: "customsBroker",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.customsBroker.writable ||
                            !_vm.customsBrokerEnabled,
                          "method-params": {
                            customsBroker: true,
                            companyLob: "seaExport",
                            active: true
                          },
                          "default-value": _vm.form.customsBroker || "",
                          placeholder: _vm.$t(
                            "SeaExport.PleaseTickCustomsDeclarationOption"
                          ),
                          "data-filter-function": _vm.customsBrokerFilter
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.customsBrokerChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customsDeclarationType.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "customsDeclarationType" },
                      slot: "customsDeclarationType"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customsDeclarationType.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customsDeclarationType.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "customsDeclarationType",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.customsDeclarationType.writable ||
                            !_vm.customsBrokerEnabled,
                          "select-type":
                            _vm.selectTypeNames
                              .basic_data_CustomsDeclarationType,
                          filterable: "",
                          "default-value":
                            _vm.form.customsDeclarationType === -1
                              ? ""
                              : _vm.form.customsDeclarationType,
                          placeholder: _vm.$t("CargoMsg.Cargo_keyWordsTip")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.customsDeclarationType = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isFba
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.CustomsDeclarationMethod")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "customsMethodPol",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.customsMethodPol.writable,
                          "select-type":
                            _vm.selectTypeNames.basic_data_CustomsMode,
                          "method-params": { serviceType: 0 },
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.fbaJob.customsMethodPol
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.fbaJob.customsMethodPol = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isFba
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ClearanceMethod") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "customsMethodPod",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.customsMethodPod.writable,
                          "select-type":
                            _vm.selectTypeNames.basic_data_CustomsMode,
                          "method-params": { serviceType: 1 },
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.fbaJob.customsMethodPod
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.fbaJob.customsMethodPod = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.tradeTerm.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "tradeTerm" }, slot: "tradeTerm" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.tradeTerm.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.tradeTerm.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "tradeTerm",
                          "select-type":
                            _vm.selectTypeNames.basic_data_TradeTerm,
                          filterable: "",
                          "default-value": _vm.form.tradeTerm,
                          disabled:
                            _vm.readonly || !_vm.elementDict.tradeTerm.writable
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.tradeTerm = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.haulageCompany.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "haulageCompany" },
                      slot: "haulageCompany"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.haulageCompany.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.haulageCompany.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-company-select", {
                        attrs: {
                          no: "carryingCmp",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.haulageCompany.writable ||
                            !_vm.form.landTransportation,
                          "method-params": { truckCmp: true, active: true },
                          "default-value": _vm.form.carryingCmp || "",
                          placeholder: _vm.$t(
                            "SeaExport.PleaseTickDoorLoadingDeliveryOption"
                          )
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.carryingCmpChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isFba
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "SeaExport.EstimatedStorageReadyGoodsTime"
                        )
                      }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.estimatedStorageReadyGoodsTime
                              .writable,
                          no: "preWarehousingTime",
                          type: "date",
                          clearable: "",
                          "value-format": "yyyy-MM-dd",
                          format: "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.fbaJob.preWarehousingTime,
                          callback: function($$v) {
                            _vm.$set(_vm.fbaJob, "preWarehousingTime", $$v)
                          },
                          expression: "fbaJob.preWarehousingTime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.warehouseCmp.viewable && !_vm.isFba
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "warehouseCmp" }, slot: "warehouseCmp" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.warehouseCmp.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.warehouseCmp.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-company-select", {
                        attrs: {
                          no: "warehouseCmp",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.warehouseCmp.writable ||
                            !_vm.warehouseEabled,
                          "method-params": { warehouse: true, active: true },
                          "default-value": _vm.form.warehouseCmp || "",
                          placeholder: _vm.$t("SeaExport.PleaseSelectWarehouse")
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.warehouseCmpChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.warehouseName.viewable &&
                        _vm.openWarehouse,
                      expression:
                        "elementDict.warehouseName.viewable && openWarehouse"
                    }
                  ],
                  attrs: { slot: "warehouseName" },
                  slot: "warehouseName"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.warehouseName.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.warehouseName.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      ref: "warehouseName",
                      attrs: {
                        no: "warehouseName",
                        disabled:
                          _vm.readonly ||
                          !_vm.elementDict.warehouseName.writable ||
                          !_vm.warehouseEabled ||
                          !_vm.form.warehouseCmp,
                        "allow-create": true,
                        filterable: "",
                        clearable: true
                      },
                      on: { change: _vm.warehouseNameChangeHandler },
                      model: {
                        value: _vm.form.warehouseName,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "warehouseName", $$v)
                        },
                        expression: "form.warehouseName"
                      }
                    },
                    _vm._l(_vm.warehouseNameList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: item.warehouseName,
                          value: item.warehouseName
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm.elementDict.backUpWarehouse.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "backUpWarehouse" },
                      slot: "backUpWarehouse"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.backUpWarehouse.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.backUpWarehouse.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "backUpWarehouseCmp",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          cache: false,
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.backUpWarehouse.writable ||
                            !_vm.backUpWarehouseEnabled,
                          "default-value": _vm.form.backUpWarehouseCmp || "",
                          filterable: "",
                          "static-options": _vm.backUpWarehouseCompanyList,
                          placeholder: !_vm.backUpWarehouseEnabled
                            ? _vm.$t("SeaExport.PleaseSelectBackUpWarehouse")
                            : _vm.$t("CargoMsg.Cargo_keyWordsTip")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.backUpWarehouseCmpChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.agentInformation &&
              _vm.elementDict.agentInformation.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "agentInformation" },
                      slot: "agentInformation"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.agentInformation.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.agentInformation.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-textarea", {
                        attrs: {
                          no: "agentInformation",
                          type: "textarea",
                          row: 3,
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.agentInformation.writable
                        },
                        model: {
                          value: _vm.form.agentInformation,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "agentInformation", $$v)
                          },
                          expression: "form.agentInformation"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isFba
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ForeignWarehouse") } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "overseaWarehouseCode",
                          "select-type":
                            _vm.selectTypeNames.basic_data_OverseaWarehouse,
                          filterable: "",
                          "method-params": { ifFba: false },
                          clearable: false,
                          "tag-name": "chineseName",
                          "default-value": _vm.form.overseaWarehouseCode,
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.overseaWarehouseCode.writable
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.overseaWarehouseCode = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.bookingTerm.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "bookingTerm" }, slot: "bookingTerm" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.bookingTerm.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.bookingTerm.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "bookingTerm",
                            disabled:
                              _vm.readonly ||
                              !_vm.elementDict.bookingTerm.writable,
                            placeholder: _vm.readonly
                              ? ""
                              : _vm.$t("SeaExport.PleaseSelect"),
                            clearable: ""
                          },
                          model: {
                            value: _vm.form.bookingTerm,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "bookingTerm", $$v)
                            },
                            expression: "form.bookingTerm"
                          }
                        },
                        _vm._l(_vm.bookingTerms, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.incoTerm.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "incoTerm" }, slot: "incoTerm" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.incoTerm.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.incoTerm.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "incoTerm",
                          "select-type":
                            _vm.selectTypeNames.basic_data_IncoTerm,
                          filterable: "",
                          "default-value": _vm.form.incoTerm,
                          disabled:
                            _vm.readonly || !_vm.elementDict.incoTerm.writable
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.incoTerm = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.prePortPlanner &&
              _vm.elementDict.prePortPlanner.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "prePortPlanner" },
                      slot: "prePortPlanner"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.prePortPlanner.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.prePortPlanner.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        staticClass: "input2",
                        attrs: {
                          no: "prePortPlanner",
                          disabled: _vm.readonly,
                          "method-params": {
                            category: "role",
                            shape: "sealine",
                            officeId: _vm.$store.getters.currentOfficeId
                          },
                          "default-value": _vm.form.prePortPlanner || "",
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.prePortPlannerChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.lastMilePlanner &&
              _vm.elementDict.lastMilePlanner.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "lastMilePlanner" },
                      slot: "lastMilePlanner"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.lastMilePlanner.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.lastMilePlanner.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        staticClass: "input2",
                        attrs: {
                          no: "lastMilePlanner",
                          disabled: _vm.readonly,
                          "method-params": {
                            category: "role",
                            shape: "sealine",
                            officeId: _vm.$store.getters.currentOfficeId
                          },
                          "default-value": _vm.form.lastMilePlanner || "",
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.lastMilePlannerChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.prePortPlannerDepartment &&
              _vm.elementDict.prePortPlannerDepartment.visible
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "prePortPlannerDepartment" },
                      slot: "prePortPlannerDepartment"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.prePortPlannerDepartment
                          .isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.prePortPlannerDepartment.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-department-select", {
                        staticClass: "input2",
                        attrs: {
                          no: "prePortPlannerDepartment",
                          disabled: _vm.readonly,
                          "office-id": Number(_vm.form.prePortPlannerOffice),
                          enables: true,
                          "department-id": Number(
                            _vm.form.prePortPlannerDepartment
                          )
                        },
                        on: {
                          change: function(p) {
                            _vm.form.prePortPlannerDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.lastMilePlannerDepartment &&
              _vm.elementDict.lastMilePlannerDepartment.visible
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "lastMilePlannerDepartment" },
                      slot: "lastMilePlannerDepartment"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.lastMilePlannerDepartment
                          .isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.lastMilePlannerDepartment.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-department-select", {
                        staticClass: "input2",
                        attrs: {
                          no: "lastMilePlannerDepartment",
                          disabled: _vm.readonly,
                          "office-id": Number(_vm.form.lastMilePlannerOffice),
                          enables: true,
                          "department-id": Number(
                            _vm.form.lastMilePlannerDepartment
                          )
                        },
                        on: {
                          change: function(p) {
                            _vm.form.lastMilePlannerDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.prePortPlannerOffice &&
              _vm.elementDict.prePortPlannerOffice.visible
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "prePortPlannerOffice" },
                      slot: "prePortPlannerOffice"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.prePortPlannerOffice.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.prePortPlannerOffice.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        staticClass: "input2",
                        attrs: {
                          no: "prePortPlannerOffice",
                          disabled: true,
                          "select-type": _vm.TYPE_NAMES.basic_data_Office,
                          filterable: "",
                          "default-value": _vm.form.prePortPlannerOffice || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.prePortPlannerOffice = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.lastMilePlannerOffice &&
              _vm.elementDict.lastMilePlannerOffice.visible
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "lastMilePlannerOffice" },
                      slot: "lastMilePlannerOffice"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.lastMilePlannerOffice.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.lastMilePlannerOffice.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        staticClass: "input2",
                        attrs: {
                          no: "lastMilePlannerOffice",
                          disabled: true,
                          "select-type": _vm.TYPE_NAMES.basic_data_Office,
                          filterable: "",
                          "default-value": _vm.form.lastMilePlannerOffice || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.lastMilePlannerOffice = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.txtWhs.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "txtWhs" }, slot: "txtWhs" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.txtWhs.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.txtWhs.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          no: "txtWhs",
                          disabled: true,
                          type: "textarea",
                          rows: 2,
                          value: _vm.txtWhs,
                          placeholder: _vm.$t("Message.NoStorageInfo")
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.remarks.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "remarks" }, slot: "remarks" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.remarks.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.remarks.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.readonly || !_vm.elementDict.remarks.writable,
                          no: "remarks",
                          type: "textarea",
                          rows: 2
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showAdvanceTextDialog(
                              _vm.elementDict.remarks.label,
                              _vm.form.remarks,
                              function(val) {
                                _vm.form.remarks = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "remarks", $$v)
                          },
                          expression: "form.remarks"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.businessTags.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "businessTags", label: " " },
                      slot: "businessTags"
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { margin: "0", "padding-right": "10px" },
                          attrs: {
                            disabled:
                              _vm.readonly ||
                              !_vm.elementDict.businessTags.writable,
                            no: "allocation"
                          },
                          model: {
                            value: _vm.form.allocation,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "allocation", $$v)
                            },
                            expression: "form.allocation"
                          }
                        },
                        [_vm._v(_vm._s("Allocation") + " ")]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: {
                            disabled:
                              _vm.readonly ||
                              !_vm.elementDict.businessTags.writable,
                            no: "availableCabinSpace"
                          },
                          model: {
                            value: _vm.form.availableCabinSpace,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "availableCabinSpace", $$v)
                            },
                            expression: "form.availableCabinSpace"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("CargoMsg.Cargo_AvailableCabinSpace")
                            ) + " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.seaEq.viewable
                ? _c("booking-sea-eq-data-grid", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      slot: "seaEq",
                      no: "seaEqList",
                      value: _vm.seaEqList,
                      "container-load-type": _vm.form.containerLoadType,
                      "is-edit": _vm.isEdit && _vm.elementDict.seaEq.writable,
                      job: _vm.form
                    },
                    on: {
                      cellChange: function() {
                        _vm.pm.dgSeaEqItemEditEndHandler()
                      },
                      eqQuantityChange: _vm.eqQuantityChangeHandler
                    },
                    slot: "seaEq"
                  })
                : _vm._e(),
              _vm.elementDict.quantityConsignActual.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "quantityConsignActual" },
                      slot: "quantityConsignActual"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.quantityConsignActual.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.quantityConsignActual.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("auto-number-input", {
                            attrs: {
                              no: "quantityContract",
                              precision: 0,
                              min: 0,
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.quantityConsignActual
                                  .writable ||
                                !_vm.isJydEditJobFields
                            },
                            on: {
                              change: function($event) {
                                _vm.SEUtils.changeQWCRule(function() {
                                  _vm.form.quantityActual =
                                    _vm.form.quantityContract
                                })
                                _vm.pm.txtPackingChangeHandler()
                              }
                            },
                            model: {
                              value: _vm.form.quantityContract,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "quantityContract", $$v)
                              },
                              expression: "form.quantityContract"
                            }
                          }),
                          _c("span", { staticStyle: { padding: "0 2px" } }, [
                            _vm._v("/")
                          ]),
                          _c("auto-number-input", {
                            attrs: {
                              no: "quantityActual",
                              precision: 0,
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.quantityConsignActual
                                  .writable ||
                                !_vm.isJydEditJobFields,
                              min: 0
                            },
                            on: {
                              change: function($event) {
                                _vm.SEUtils.changeQWCRule(null, function() {
                                  _vm.form.quantityContract =
                                    _vm.form.quantityActual
                                })
                              }
                            },
                            model: {
                              value: _vm.form.quantityActual,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "quantityActual", $$v)
                              },
                              expression: "form.quantityActual"
                            }
                          }),
                          _c("span", [_vm._v("PCS")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.weightConsignActual.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "weightConsignActual" },
                      slot: "weightConsignActual"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.weightConsignActual.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.weightConsignActual.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("auto-number-input", {
                            attrs: {
                              no: "weightContract",
                              precision: 3,
                              min: 0,
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.weightConsignActual.writable ||
                                !_vm.isJydEditJobFields
                            },
                            on: { change: _vm.weightContractChange },
                            model: {
                              value: _vm.form.weightContract,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "weightContract", $$v)
                              },
                              expression: "form.weightContract"
                            }
                          }),
                          _c("span", { staticStyle: { padding: "0 2px" } }, [
                            _vm._v("/")
                          ]),
                          _c("auto-number-input", {
                            attrs: {
                              no: "weightActual",
                              precision: 3,
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.weightConsignActual.writable ||
                                !_vm.isJydEditJobFields,
                              min: 0
                            },
                            on: { change: _vm.weightActualChange },
                            model: {
                              value: _vm.form.weightActual,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "weightActual", $$v)
                              },
                              expression: "form.weightActual"
                            }
                          }),
                          _c("span", [_vm._v("KGS")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cubageConsignActual.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "cubageConsignActual" },
                      slot: "cubageConsignActual"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cubageConsignActual.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cubageConsignActual.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("auto-number-input", {
                            attrs: {
                              no: "cubageContract",
                              precision: 3,
                              min: 0,
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.cubageConsignActual.writable ||
                                !_vm.cubageActualEnabled ||
                                !_vm.isJydEditJobFields
                            },
                            on: { change: _vm.cubageContractChange },
                            model: {
                              value: _vm.form.cubageContract,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cubageContract", $$v)
                              },
                              expression: "form.cubageContract"
                            }
                          }),
                          _c("span", { staticStyle: { padding: "0 2px" } }, [
                            _vm._v("/")
                          ]),
                          _c("auto-number-input", {
                            attrs: {
                              no: "cubageActual",
                              precision: 3,
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.cubageConsignActual.writable ||
                                !_vm.cubageActualEnabled ||
                                !_vm.isJydEditJobFields,
                              min: 0
                            },
                            on: { change: _vm.cubageActualChange },
                            model: {
                              value: _vm.form.cubageActual,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cubageActual", $$v)
                              },
                              expression: "form.cubageActual"
                            }
                          }),
                          _c("span", [_vm._v("CBM")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isFba
                ? _c("el-form-item", { attrs: { "label-width": "0" } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-around"
                        }
                      },
                      [
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: {
                              "margin-right": "10px",
                              "margin-left": "20px"
                            },
                            attrs: { disabled: _vm.readonly },
                            model: {
                              value: _vm.fbaJob.electric,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "electric", $$v)
                              },
                              expression: "fbaJob.electric"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.WithElectricity")))]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "margin-right": "10px" },
                            attrs: { disabled: _vm.readonly },
                            model: {
                              value: _vm.fbaJob.magnetic,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "magnetic", $$v)
                              },
                              expression: "fbaJob.magnetic"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.WithMagnetism")))]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "margin-right": "10px" },
                            attrs: { disabled: _vm.readonly },
                            model: {
                              value: _vm.fbaJob.powdery,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "powdery", $$v)
                              },
                              expression: "fbaJob.powdery"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Powder")))]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "margin-right": "10px" },
                            attrs: { disabled: _vm.readonly },
                            model: {
                              value: _vm.fbaJob.liquid,
                              callback: function($$v) {
                                _vm.$set(_vm.fbaJob, "liquid", $$v)
                              },
                              expression: "fbaJob.liquid"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Liquid")))]
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.elementDict.packing.viewable,
                      expression: "elementDict.packing.viewable"
                    }
                  ],
                  attrs: { slot: "packing" },
                  slot: "packing"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.packing.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.packing.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-packing-select", {
                    ref: "packing",
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "packing",
                      "default-value": _vm.form.packing,
                      disabled:
                        _vm.readonly || !_vm.elementDict.packing.writable
                    },
                    on: {
                      change: function(p) {
                        _vm.form.packing = p.value
                        _vm.pm.txtPackingChangeHandler()
                      }
                    }
                  })
                ],
                1
              ),
              _vm.elementDict.chargeWeight.viewable && !_vm.isFba
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "chargeWeight" }, slot: "chargeWeight" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.chargeWeight.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.chargeWeight.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-input-number", {
                            staticStyle: { flex: "1" },
                            attrs: {
                              no: "chargeWeight",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.chargeWeight.writable,
                              value: _vm.form.chargeWeight || undefined,
                              precision: 3,
                              min: 0,
                              controls: false
                            },
                            on: {
                              input: function(val) {
                                _vm.form.chargeWeight = val
                                _vm.context.reloadCharge = true
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.isFba ? "KGS" : "M/T"))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cargoChineseName.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "cargoChineseName" },
                      slot: "cargoChineseName"
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "label" }, slot: "label" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.cargoChineseName.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              label: _vm.elementDict.cargoChineseName.label
                            }
                          }),
                          _c("br"),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.isEdit &&
                                    _vm.elementDict.cargoChineseName.writable,
                                  expression:
                                    "isEdit && elementDict.cargoChineseName.writable"
                                }
                              ],
                              attrs: {
                                no: "MergingTickets",
                                disabled:
                                  _vm.readonly ||
                                  !_vm.elementDict.cargoChineseName.writable,
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.pm.mergeLclCargoDocInfo(
                                    "cargoChineseName",
                                    _vm.form
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.MergingTickets")))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { position: "relative" } },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.cargoChineseName.writable,
                              type: "textarea",
                              rows: 3,
                              no: "cargoChineseName"
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.ChineseDescriptionOfGoods"),
                                  _vm.form.cargoChineseName,
                                  function(val) {
                                    _vm.form.cargoChineseName = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.cargoChineseName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cargoChineseName", $$v)
                              },
                              expression: "form.cargoChineseName"
                            }
                          }),
                          _c("char-count", {
                            attrs: { value: _vm.form.cargoChineseName }
                          })
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm.elementDict.cargoEnglishName.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "cargoEnglishName" },
                      slot: "cargoEnglishName"
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "label" }, slot: "label" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.cargoEnglishName.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              label: _vm.elementDict.cargoEnglishName.label
                            }
                          }),
                          _c("br"),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.isEdit &&
                                    _vm.elementDict.cargoEnglishName.writable,
                                  expression:
                                    "isEdit && elementDict.cargoEnglishName.writable"
                                }
                              ],
                              attrs: {
                                type: "primary",
                                no: "EnglishDescriptionOfGoods"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.pm.mergeLclCargoDocInfo(
                                    "cargoEnglishName",
                                    _vm.form
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.MergingTickets")))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "special-character-tip",
                        {
                          attrs: {
                            texts: _vm.specialCharCheck.cargoEnglishName
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { position: "relative" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  no: "cargoEnglishName",
                                  disabled:
                                    _vm.readonly ||
                                    !_vm.elementDict.cargoEnglishName.writable,
                                  type: "textarea",
                                  rows: 3
                                },
                                on: { input: _vm.handleInputCargoEnglishName },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showAdvanceTextDialog(
                                      _vm.elementDict.cargoEnglishName.label,
                                      _vm.form.cargoEnglishName,
                                      function(val) {
                                        _vm.form.cargoEnglishName = val
                                      },
                                      _vm.isUppercaseByConfig,
                                      { autoUppercase: _vm.isUppercaseByConfig }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.cargoEnglishName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "cargoEnglishName", $$v)
                                  },
                                  expression: "form.cargoEnglishName"
                                }
                              }),
                              _c("char-count", {
                                attrs: { value: _vm.form.cargoEnglishName }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.mark.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "mark" }, slot: "mark" },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "label" }, slot: "label" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.mark.isRequire ? "blue" : "",
                            attrs: { label: _vm.elementDict.mark.label }
                          }),
                          _c("br"),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.isEdit && _vm.elementDict.mark.writable,
                                  expression:
                                    "isEdit && elementDict.mark.writable"
                                }
                              ],
                              staticStyle: { "margin-left": "10px" },
                              attrs: { no: "Marks", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.pm.mergeLclCargoDocInfo(
                                    "mark",
                                    _vm.form
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.MergingTickets")))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "special-character-tip",
                        { attrs: { texts: _vm.specialCharCheck.mark } },
                        [
                          _c(
                            "div",
                            { staticStyle: { position: "relative" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled:
                                    _vm.readonly ||
                                    !_vm.elementDict.mark.writable,
                                  no: "mark",
                                  type: "textarea",
                                  rows: 3
                                },
                                on: { input: _vm.handleInputMark },
                                nativeOn: {
                                  dblclick: function($event) {
                                    return _vm.showAdvanceTextDialog(
                                      _vm.elementDict.mark.label,
                                      _vm.form.mark,
                                      function(val) {
                                        _vm.form.mark = val
                                      },
                                      _vm.isUppercaseByConfig,
                                      { autoUppercase: _vm.isUppercaseByConfig }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.mark,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "mark", $$v)
                                  },
                                  expression: "form.mark"
                                }
                              }),
                              _c("char-count", {
                                attrs: { value: _vm.form.mark }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cargoCode.viewable
                ? _c(
                    "template",
                    { slot: "cargoCode" },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "custom" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.cargoCode.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.cargoCode.label
                            },
                            slot: "label"
                          }),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "cargoCode",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CargoInformation,
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.cargoCode.writable,
                              filterable: "",
                              clearable: true,
                              "default-value": _vm.form.cargoCode,
                              "allow-create": false
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.cargoCodeChange(p.value)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: {
                              no: "cargoName",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.cargoCode.writable ||
                                !(_vm.isEdit && _vm.form.cargoCode)
                            },
                            model: {
                              value: _vm.form.cargoName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cargoName", $$v)
                              },
                              expression: "form.cargoName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.salesChannel.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "salesChannel" }, slot: "salesChannel" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.salesChannel.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.salesChannel.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { value: _vm.form.salesChannel, disabled: true }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.channelNo.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "channelNo" }, slot: "channelNo" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.channelNo.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.channelNo.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { value: _vm.form.channelNo, disabled: true }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.trustFromJob &&
              _vm.elementDict.trustFromJob.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "trustFromJob" }, slot: "trustFromJob" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.trustFromJob.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.trustFromJob.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { value: _vm.form.trustFromJob, disabled: true }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.relatedJob && _vm.elementDict.relatedJob.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "relatedJob" }, slot: "relatedJob" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.relatedJob.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.relatedJob.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { value: _vm.form.relatedJob, disabled: true }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.salesCompany.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "salesCompany" }, slot: "salesCompany" },
                    [
                      _c("line-label", {
                        class:
                          _vm.elementDict.salesCompany.isRequire &&
                          _vm.form.containerLoadType !== _vm.LCL_CARGO_TYPE.code
                            ? "blue"
                            : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.salesCompany.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { value: _vm.txtSalesOffice, disabled: true }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.elementDict.sales.viewable,
                      expression: "elementDict.sales.viewable"
                    }
                  ],
                  attrs: { slot: "sales" },
                  slot: "sales"
                },
                [
                  _c("line-label", {
                    class:
                      _vm.elementDict.sales.isRequire &&
                      _vm.form.containerLoadType !== _vm.LCL_CARGO_TYPE.code
                        ? "blue"
                        : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.sales.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "sales",
                    attrs: {
                      no: "sales",
                      disabled: _vm.readonly || !_vm.elementDict.sales.writable,
                      "method-params": {
                        officeId: _vm.salesOfficeCheck
                          ? _vm.$store.getters.currentOfficeId
                          : "",
                        category: "role",
                        shape: "sales"
                      },
                      "default-value": _vm.form.sales || "",
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.txtSalesChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              ),
              _vm.elementDict.cargoSalesId.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "cargoSalesId" }, slot: "cargoSalesId" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoSalesId.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cargoSalesId.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        attrs: {
                          no: "cargoSalesId",
                          "method-params": {
                            category: "role",
                            shape: "salesOfGoods"
                          },
                          "default-value": _vm.form.cargoSalesId || "",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.cargoSalesId.writable,
                          "merge-load": true,
                          "static-options": _vm.cargoSalesList
                        },
                        on: {
                          change: function(p) {
                            _vm.form.cargoSalesId = p.value
                            _vm.pm.cargoSalesChargeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.salesDepartment.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "salesDepartment" },
                      slot: "salesDepartment"
                    },
                    [
                      _c("line-label", {
                        class:
                          _vm.elementDict.salesDepartment.isRequire &&
                          _vm.form.containerLoadType !== _vm.LCL_CARGO_TYPE.code
                            ? "blue"
                            : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.salesDepartment.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-department-new-select", {
                        attrs: {
                          no: "salesOffice",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.sales.writable ||
                            !_vm.form.sales,
                          "sales-id": Number(_vm.form.sales),
                          "office-id": _vm.form.salesOffice,
                          enables: true,
                          "department-id": Number(_vm.form.salesDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.salesDepartment = p.value
                            _vm.pm.departmentChargeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.opOffice.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "opOffice" }, slot: "opOffice" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.opOffice.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.opOffice.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-office-select", {
                        attrs: {
                          no: "opOffice",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.opOffice.writable ||
                            (!_vm.isRegionalCommission &&
                              _vm.pm.isEntrustOrder(true)) ||
                            _vm.opOfficeDisabled,
                          "is-regional-commission": _vm.isRegionalCommission,
                          "office-id": Number(_vm.form.opOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.opOffice = p.value
                            _vm.form.opDepartment = 0
                            _vm.opOfficeChargeHandler()
                            _vm.contractRuleFieldChange(
                              _vm.form.customerId,
                              _vm.form.designationAgent
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.opDepartment.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "opDepartment" }, slot: "opDepartment" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.opDepartment.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.opDepartment.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "opDepartment",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.opDepartment.writable ||
                            _vm.pm.isWithinCloseAccountDate,
                          "office-id": Number(_vm.form.opOffice),
                          enables: true,
                          "department-id": Number(_vm.form.opDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.opDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.elementDict.op.viewable,
                      expression: "elementDict.op.viewable"
                    }
                  ],
                  attrs: { slot: "op" },
                  slot: "op"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.op.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.op.label },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "op",
                    attrs: {
                      no: "op",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.op.writable ||
                        !_vm.opEabled,
                      "method-params": {
                        officeId: _vm.form.opOffice,
                        category: "role",
                        shape: "op"
                      },
                      "default-value": _vm.form.op || "",
                      "merge-load": true,
                      "static-options": _vm.userPortRoleData.op
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.txtOPChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              ),
              _vm.elementDict.csrOffice.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "csrOffice" }, slot: "csrOffice" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.csrOffice.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.csrOffice.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-office-select", {
                        attrs: {
                          no: "csrOffice",
                          disabled: true,
                          "office-id": Number(_vm.form.csrOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.csrOffice = p.value
                            _vm.form.csrDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.csrDepartment.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "csrDepartment" }, slot: "csrDepartment" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.csrDepartment.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.csrDepartment.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "csrDepartment",
                          "office-id": Number(_vm.form.csrOffice),
                          enables: true,
                          "department-id": Number(_vm.form.csrDepartment),
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.csrDepartment.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.form.csrDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.csr.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "csr" }, slot: "csr" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.csr.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.csr.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        attrs: {
                          no: "csr",
                          "method-params": {
                            officeId:
                              _vm.pm.isEntrustOrder ||
                              _vm.form.salesOffice === 1
                                ? _vm.form.opOffice
                                : _vm.form.salesOffice,
                            category: "role",
                            shape: "csr"
                          },
                          "default-value": _vm.form.csr || "",
                          disabled:
                            _vm.readonly || !_vm.elementDict.csr.writable,
                          "merge-load": true,
                          "static-options": _vm.userPortRoleData.csr
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.csrChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.siteOP.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "siteOP" }, slot: "siteOP" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.siteOP.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.siteOP.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        attrs: {
                          "method-params": {
                            officeId: _vm.form.opOffice,
                            category: "role",
                            shape: "siteOp"
                          },
                          "default-value": _vm.form.siteOP || "",
                          disabled:
                            _vm.readonly || !_vm.elementDict.siteOP.writable,
                          "static-options": _vm.userPortRoleData.siteOp
                        },
                        on: {
                          change: function(p) {
                            _vm.JobUtils.siteOpChangeHandler(_vm.form, p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.overseaOp.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "overseaOp" }, slot: "overseaOp" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.overseaOp.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.overseaOp.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        attrs: {
                          no: "overseaOp",
                          "default-value": _vm.form.overseaOp || "",
                          disabled:
                            _vm.readonly || !_vm.elementDict.overseaOp.writable,
                          "method-params": {
                            category: "role",
                            shape: "overseaOp"
                          },
                          "static-options": _vm.isHC
                            ? null
                            : _vm.userPortRoleData.overseaOp ||
                              _vm.overseaOpList,
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.overseaOpChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.dcOffice.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "dcOffice" }, slot: "dcOffice" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.dcOffice.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.dcOffice.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-office-select", {
                        attrs: {
                          no: "dcOffice",
                          disabled: true,
                          "office-id": Number(_vm.form.dcOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.dcOffice = p.value
                            _vm.form.dcDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.dcDepartment.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "dcDepartment" }, slot: "dcDepartment" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.dcDepartment.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.dcDepartment.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "dcDepartment",
                          "office-id": Number(_vm.form.dcOffice),
                          enables: true,
                          "department-id": Number(_vm.form.dcDepartment),
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.dcDepartment.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.form.dcDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.dc.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "dc" }, slot: "dc" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.dc.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.dc.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        attrs: {
                          no: "dc",
                          "method-params": {
                            officeId: _vm.form.opOffice,
                            category: "role",
                            shape: "doc"
                          },
                          "default-value": _vm.form.dc || "",
                          disabled:
                            _vm.readonly || !_vm.elementDict.dc.writable,
                          "merge-load": true,
                          "static-options": _vm.userPortRoleData.doc
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.dcChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.plannerOffice &&
              _vm.elementDict.plannerOffice.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "plannerOffice" }, slot: "plannerOffice" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.plannerOffice.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.plannerOffice.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-office-select", {
                        attrs: {
                          no: "plannerOffice",
                          disabled: true,
                          "office-id": Number(_vm.form.plannerOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.plannerOffice = p.value
                            _vm.form.plannerDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.plannerDepartment &&
              _vm.elementDict.plannerDepartment.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "plannerDepartment" },
                      slot: "plannerDepartment"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.plannerDepartment.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.plannerDepartment.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "plannerDepartment",
                          "office-id": Number(_vm.form.plannerOffice),
                          enables: true,
                          "department-id": Number(_vm.form.plannerDepartment),
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.plannerDepartment.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.form.plannerDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.planner.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "planner" }, slot: "planner" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.planner.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.planner.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        attrs: {
                          no: "planner",
                          "method-params": {
                            category: "role",
                            shape: "sealine"
                          },
                          "default-value": _vm.form.planner || "",
                          disabled:
                            _vm.readonly || !_vm.elementDict.planner.writable,
                          "merge-load": true,
                          "static-options": _vm.userPortRoleData.seaLine
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.txtPlannerChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.userDefinedRoleId1.viewable &&
                        _vm.isAddUserDefinedRoles,
                      expression:
                        "elementDict.userDefinedRoleId1.viewable && isAddUserDefinedRoles"
                    }
                  ],
                  attrs: { slot: "userDefinedRoleId1" },
                  slot: "userDefinedRoleId1"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId1.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId1.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId1",
                    attrs: {
                      no: "userDefinedRoleId1",
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole1"
                      },
                      "default-value": _vm.form.userDefinedRoleId1 || "",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.userDefinedRoleId1.writable,
                      "merge-load": true,
                      "static-options": _vm.userPortRoleData.userDefinedRole1
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.userDefinedRoleId1Handler(p)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.userDefinedRoleId2.viewable &&
                        _vm.isAddUserDefinedRoles,
                      expression:
                        "elementDict.userDefinedRoleId2.viewable && isAddUserDefinedRoles"
                    }
                  ],
                  attrs: { slot: "userDefinedRoleId2" },
                  slot: "userDefinedRoleId2"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId2.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId2.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId2",
                    attrs: {
                      no: "userDefinedRoleId2",
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole2"
                      },
                      "default-value": _vm.form.userDefinedRoleId2 || "",
                      disabled:
                        _vm.readonly ||
                        !_vm.elementDict.userDefinedRoleId2.writable,
                      "merge-load": true,
                      "static-options": _vm.userPortRoleData.userDefinedRole2
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.userDefinedRoleId2Handler(p)
                      }
                    }
                  })
                ],
                1
              ),
              _vm.elementDict.userDefinedRoleId3 &&
              _vm.elementDict.userDefinedRoleId3.viewable &&
              _vm.isAddUserDefinedRoles
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId3" },
                      slot: "userDefinedRoleId3"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId3.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId3.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId3",
                        attrs: {
                          no: "userDefinedRoleId3",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.userDefinedRoleId3.writable,
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole3"
                          },
                          "default-value": _vm.form.userDefinedRoleId3 || "",
                          "merge-load": true,
                          "static-options":
                            _vm.userPortRoleData.userDefinedRole3
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId3Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedRoleId4 &&
              _vm.elementDict.userDefinedRoleId4.viewable &&
              _vm.isAddUserDefinedRoles
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId4" },
                      slot: "userDefinedRoleId4"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId4.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId4.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId4",
                        attrs: {
                          no: "userDefinedRoleId4",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.userDefinedRoleId4.writable,
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole4"
                          },
                          "default-value": _vm.form.userDefinedRoleId4 || "",
                          "merge-load": true,
                          "static-options":
                            _vm.userPortRoleData.userDefinedRole4
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId4Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedRoleId5 &&
              _vm.elementDict.userDefinedRoleId5.viewable &&
              _vm.isAddUserDefinedRoles
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId5" },
                      slot: "userDefinedRoleId5"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId5.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId5.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId5",
                        attrs: {
                          no: "userDefinedRoleId5",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole5"
                          },
                          "default-value": _vm.form.userDefinedRoleId5 || "",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.userDefinedRoleId5.writable,
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId5Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedRoleId6 &&
              _vm.elementDict.userDefinedRoleId6.viewable &&
              _vm.isAddUserDefinedRoles
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId6" },
                      slot: "userDefinedRoleId6"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId6.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId6.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId6",
                        attrs: {
                          no: "userDefinedRoleId6",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole6"
                          },
                          "default-value": _vm.form.userDefinedRoleId6 || "",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.userDefinedRoleId6.writable,
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId6Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedRoleId7 &&
              _vm.elementDict.userDefinedRoleId7.viewable &&
              _vm.isAddUserDefinedRoles
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId7" },
                      slot: "userDefinedRoleId7"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId7.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId7.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId7",
                        attrs: {
                          no: "userDefinedRoleId7",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole7"
                          },
                          "default-value": _vm.form.userDefinedRoleId7 || "",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.userDefinedRoleId7.writable,
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId7Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedRoleId8 &&
              _vm.elementDict.userDefinedRoleId8.viewable &&
              _vm.isAddUserDefinedRoles
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId8" },
                      slot: "userDefinedRoleId8"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId8.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId8.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId8",
                        attrs: {
                          no: "userDefinedRoleId8",
                          disabled: _vm.readonly,
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole8"
                          },
                          "default-multiple-value": _vm.toNumArray(
                            _vm.form.userDefinedRoleId8
                          ),
                          multiple: true,
                          "merge-load": true,
                          placeholder: _vm.readonly ? " " : ""
                        },
                        on: {
                          change: function(p) {
                            _vm.form.userDefinedRoleId8 = _vm.toTxt(p.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedField1.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedField1" },
                      slot: "userDefinedField1"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedField1.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedField1.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.userDefinedField1.writable,
                          no: "userDefinedField1",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showAdvanceTextDialog(
                              _vm.elementDict.userDefinedField1.label,
                              _vm.form.userDefinedField1,
                              function(val) {
                                _vm.form.userDefinedField1 = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.userDefinedField1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "userDefinedField1", $$v)
                          },
                          expression: "form.userDefinedField1"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedField2.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedField2" },
                      slot: "userDefinedField2"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedField2.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedField2.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.userDefinedField2.writable,
                          no: "userDefinedField2",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showAdvanceTextDialog(
                              _vm.elementDict.userDefinedField2.label,
                              _vm.form.userDefinedField2,
                              function(val) {
                                _vm.form.userDefinedField2 = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.userDefinedField2,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "userDefinedField2", $$v)
                          },
                          expression: "form.userDefinedField2"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedField3.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedField3" },
                      slot: "userDefinedField3"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedField3.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedField3.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.userDefinedField3.writable,
                          no: "userDefinedField3",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showAdvanceTextDialog(
                              _vm.elementDict.userDefinedField3.label,
                              _vm.form.userDefinedField3,
                              function(val) {
                                _vm.form.userDefinedField3 = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.userDefinedField3,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "userDefinedField3", $$v)
                          },
                          expression: "form.userDefinedField3"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedField4.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedField4" },
                      slot: "userDefinedField4"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedField4.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedField4.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.userDefinedField4.writable,
                          no: "userDefinedField4",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showAdvanceTextDialog(
                              _vm.elementDict.userDefinedField4.label,
                              _vm.form.userDefinedField4,
                              function(val) {
                                _vm.form.userDefinedField4 = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.userDefinedField4,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "userDefinedField4", $$v)
                          },
                          expression: "form.userDefinedField4"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.exportControlledProduct &&
              _vm.elementDict.exportControlledProduct.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "exportControlledProduct" },
                      slot: "exportControlledProduct"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.exportControlledProduct.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.exportControlledProduct.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "exportControlledProduct",
                            disabled:
                              _vm.readonly ||
                              !_vm.elementDict.exportControlledProduct.writable,
                            placeholder: "",
                            clearable: true,
                            size: "mini"
                          },
                          model: {
                            value: _vm.form.exportControlledProduct,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "exportControlledProduct", $$v)
                            },
                            expression: "form.exportControlledProduct"
                          }
                        },
                        _vm._l(_vm.EXPORT_CONTROLLED_PRODUCT, function(
                          item,
                          index
                        ) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.taxNature && _vm.elementDict.taxNature.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "taxNature" }, slot: "taxNature" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.taxNature.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.taxNature.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled:
                              _vm.readonly ||
                              !_vm.elementDict.taxNature.writable,
                            no: "taxNature",
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            size: "mini"
                          },
                          model: {
                            value: _vm.form.taxNature,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "taxNature", $$v)
                            },
                            expression: "form.taxNature"
                          }
                        },
                        _vm._l(_vm.TAX_NATURES, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.rateType && _vm.elementDict.rateType.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "rateType" }, slot: "rateType" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.rateType.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.rateType.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled:
                              _vm.readonly ||
                              !_vm.elementDict.rateType.writable,
                            no: "rateType",
                            clearable: "",
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            size: "mini"
                          },
                          model: {
                            value: _vm.form.rateType,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "rateType", $$v)
                            },
                            expression: "form.rateType"
                          }
                        },
                        _vm._l(_vm.rateType, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.loadingAgentId &&
              _vm.elementDict.loadingAgentId.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "loadingAgentId" },
                      slot: "loadingAgentId"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.loadingAgentId.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.loadingAgentId.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-company-select", {
                        attrs: {
                          "method-params": { localAgent: true, active: true },
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.loadingAgentId.writable,
                          no: "loadingAgentId",
                          "default-value": _vm.form.loadingAgentId || "",
                          "data-filter-function":
                            _vm.JobUtils.loadingAgentIdFilter,
                          "tag-name": _vm.isZh ? "chineseName" : "englishName"
                        },
                        on: {
                          change: function(p) {
                            _vm.form.loadingAgentId = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "section",
                  staticStyle: { width: "100%" },
                  attrs: { slot: "ticketsInfo" },
                  slot: "ticketsInfo"
                },
                [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(" " + _vm._s(_vm.$t("SeaExport.TicketsInfo")) + " "),
                    _c(
                      "div",
                      {
                        ref: "division",
                        staticClass: "division",
                        style: { height: _vm.divisionHeight + "px" },
                        on: {
                          mousedown: function($event) {
                            _vm.divisionEnabled = true
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "line",
                          staticStyle: { "margin-top": "2px" }
                        }),
                        _c("div", { staticClass: "line" })
                      ]
                    )
                  ]),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                        "margin-bottom": "5px",
                        "line-height": "28px"
                      }
                    },
                    [
                      _c("div", { staticStyle: { padding: "5px 0" } }, [
                        _c("span", { staticStyle: { "margin-right": "5px" } }, [
                          _vm._v(_vm._s(_vm.$t("SeaExport.TotalTickets")) + ":")
                        ]),
                        _c("span", { staticStyle: { "margin-right": "5px" } }, [
                          _vm._v(_vm._s(_vm.form.lclSlaves.length))
                        ]),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.readonly &&
                                  _vm.viewSource === "bookingWorkspace",
                                expression:
                                  "readonly&&viewSource==='bookingWorkspace'"
                              }
                            ],
                            staticStyle: { display: "inline-flex" }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "NewTickets",
                                  disabled:
                                    !_vm.isSeaExport ||
                                    _vm.viewSource === "financeDetail" ||
                                    _vm.viewSource === "salesDetail",
                                  type: "primary"
                                },
                                on: { click: _vm.btnCreateClickHandler }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.NewTickets")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "EditTickets",
                                  disabled:
                                    !_vm.selectedRow ||
                                    _vm.viewSource === "financeDetail" ||
                                    _vm.viewSource === "salesDetail",
                                  type: "primary"
                                },
                                on: { click: _vm.btnLcLEditClickHandler }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.EditTickets")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "AddTickets",
                                  disabled:
                                    !_vm.isSeaExport ||
                                    _vm.viewSource === "financeDetail" ||
                                    _vm.viewSource === "salesDetail",
                                  type: "primary"
                                },
                                on: { click: _vm.btnImportLclClickHandler }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.AddTickets")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "RemoveTickets",
                                  disabled:
                                    !_vm.selectedRow ||
                                    _vm.viewSource === "financeDetail" ||
                                    _vm.viewSource === "salesDetail",
                                  type: "danger"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.btnRemoveBatchClickHandler()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.RemoveTickets"))
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: [
                                      "button_fmBookingNew_deleteSmallTicket"
                                    ],
                                    expression:
                                      "['button_fmBookingNew_deleteSmallTicket']"
                                  }
                                ],
                                attrs: {
                                  no: "DeleteTickets",
                                  disabled:
                                    !_vm.selectedRow ||
                                    _vm.viewSource === "financeDetail" ||
                                    _vm.viewSource === "salesDetail",
                                  type: "danger"
                                },
                                on: { click: _vm.btnRemoveClickHandler }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.DeleteTickets"))
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _c(
                        "div",
                        { ref: "slaveDiv", staticStyle: { display: "flex" } },
                        [
                          _c("cargo-ag-grid", {
                            attrs: {
                              "config-module": "130125",
                              "grid-options": _vm.gridOptions,
                              "column-defs": _vm.columnDefs,
                              "row-data": _vm.rowData
                            },
                            on: {
                              gridReady: function(params) {
                                _vm.gridApi = params.api
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]
              )
            ],
            2
          ),
          _c("query-se-lcl-dialog", {
            attrs: { visible: _vm.querySELclDialog.visible, job: _vm.form },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.querySELclDialog, "visible", $event)
              },
              callback: function(rows) {
                _vm.pm.slavedAddedHandler(rows)
              }
            }
          }),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                no: "ticketDialog",
                visible: _vm.ticketDialog.visible,
                title: _vm.$t("SeaExport.FillInQuantityOfVotes"),
                width: "270px",
                "close-on-click-modal": false,
                "close-on-press-escape": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.ticketDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "50px", "label-position": "right" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Number") + "：" } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          precision: 0,
                          min: 1,
                          max: 50,
                          controls: false
                        },
                        model: {
                          value: _vm.ticketDialog.value,
                          callback: function($$v) {
                            _vm.$set(_vm.ticketDialog, "value", $$v)
                          },
                          expression: "ticketDialog.value"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "ticketDialogConfirm", type: "primary" },
                      on: { click: _vm.toAddTicket }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "ticketDialogCancel", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.ticketDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                no: "ContactPerson",
                visible: _vm.contactDialog.visible,
                title: _vm.$t("SeaExport.ContactPerson"),
                width: "400px",
                "append-to-body": "",
                "close-on-click-modal": false,
                "close-on-press-escape": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.contactDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  attrs: { "label-position": "right", "label-width": "100px" }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.ContactPerson") + "：" }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "170px" },
                        attrs: {
                          disabled: true,
                          value: _vm.contactDialog.data.contactPerson
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Role") + "：" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "170px" },
                        attrs: {
                          disabled: true,
                          value: _vm.contactDialog.data.role
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Tel") + "：" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "170px" },
                        attrs: {
                          disabled: true,
                          value: _vm.contactDialog.data.telephone
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Mobile") + "：" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "170px" },
                        attrs: {
                          disabled: true,
                          value: _vm.contactDialog.data.mobile
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Fax") + "：" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "170px" },
                        attrs: {
                          disabled: true,
                          value: _vm.contactDialog.data.fax
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Email") + "：" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "170px" },
                        attrs: {
                          disabled: true,
                          value: _vm.contactDialog.data.email
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") + "：" }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "170px" },
                        attrs: {
                          disabled: true,
                          value: _vm.contactDialog.data.remarks,
                          type: "textarea",
                          rows: 3
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                no: "advanceTextDialog",
                visible: _vm.advanceTextDialog.visible,
                title: _vm.advanceTextDialog.title,
                width: "600px",
                "close-on-click-modal": false,
                "close-on-press-escape": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.advanceTextDialog, "visible", $event)
                }
              }
            },
            [
              _c("cargo-rich-textarea", {
                staticStyle: { height: "320px" },
                attrs: { disabled: _vm.readonly },
                model: {
                  value: _vm.advanceTextDialog.value,
                  callback: function($$v) {
                    _vm.$set(_vm.advanceTextDialog, "value", $$v)
                  },
                  expression: "advanceTextDialog.value"
                }
              }),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        }
                      ],
                      attrs: {
                        no: "advanceTextDialogConfirm",
                        type: "primary"
                      },
                      on: { click: _vm.finishAdvanceText }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "advanceTextDialogClose" },
                      on: {
                        click: function($event) {
                          _vm.advanceTextDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }